export default __webpack_public_path__ + "static/media/User.27983814.svg";